export type SingpassLoginError = 'unavailable' | 'retry' | 'denied' | 'failed';

/** Maps the singpassError query to one of the four codes. Any other value is failed. Absent means success. */
export function singpassLoginError(value: string | null | undefined): SingpassLoginError | null {
  if (!value) return null;
  if (value === 'unavailable' || value === 'retry' || value === 'denied' || value === 'failed') return value;
  return 'failed';
}

export function singpassStaffNotice(code: SingpassLoginError, allowHq: boolean): string {
  if (code === 'unavailable') {
    return allowHq
      ? 'Singpass is temporarily unavailable. Sign in with HQ, or try Singpass again.'
      : 'Singpass is temporarily unavailable. Try again.';
  }
  if (code === 'retry') return 'Singpass could not sign you in. Try again.';
  if (code === 'denied') return 'Singpass sign-in was cancelled. Try again.';
  return 'Singpass sign-in could not be completed. Try again.';
}
